import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

import "./DestinationCarousel.css";

import australia from "../Assets/australia.png";
import canada from "../Assets/canada.png";
import ireland from "../Assets/ireland.png";
import newzealand from "../Assets/newzealand.png";
import uk from '../Assets/destUk.png'
import asia from '../Assets/destAsia.png'
import usa from '../Assets/destUsa.png'
import dubai from '../Assets/destdubai.png'
import europe from '../Assets/desteurope.png'
import france from '../Assets/destfrance.png'
import germany from '../Assets/destgermany.png'
import singapore from '../Assets/destsingapore.png'
import switzerland from '../Assets/destswitzerland.png'
import Netherland from '../Assets/desNetherland.png'
import Italy from '../Assets/desItaly.png'
import Poland from '../Assets/desPoland.png'
import Georgia from '../Assets/desGeorgia.png'
import Russia from '../Assets/desRussia.png'
import Kyrgyzstan from '../Assets/desKyrgyzstan.png'
import Kazakhstan from '../Assets/desKazakhstan.png'
import Uzbekistan from '../Assets/desUzbekistan.png'
import Afghanistan from '../Assets/desAfghanistan.png'
import China from '../Assets/china.png'
import SouthKorea from '../Assets/southkorea.png'


const destinations = [
  {
    title: "Australia",
    desc: "Discover endless opportunities in Australia! With 1,100+ institutions and 22,000 courses, you’ll enjoy world-class education and an exceptional quality of life.",
    img: australia,
    highlight: true,
  },
  { title: "Canada", img: canada, desc: "Canada offers globally recognized degrees, vibrant multicultural campuses, and a high quality of life.",   highlight: true, },
  { title: "Ireland", img: ireland, desc: "Ireland is known for its friendly culture, innovative research, and beautiful landscapes.",  highlight: true, },
  { title: "New Zealand", img: newzealand, desc: "New Zealand combines top-ranked universities with breathtaking scenery.",  highlight: true,  },
    { title: "UK", img: uk, desc: "The UK offers world-renowned universities and a rich cultural heritage.", highlight: true },
    { title: "Asia", img: asia, desc: "Asia is home to rapidly growing educational hubs with diverse learning opportunities.", highlight: true },
    { title: "USA", img: usa, desc: "The USA combines top-ranked universities with vibrant campus life and innovation.", highlight: true },
    { title: "Dubai", img: dubai, desc: "Dubai offers modern universities and international exposure in a dynamic city.", highlight: true },
    { title: "Europe", img: europe, desc: "Europe offers historic universities and a blend of culture, research, and travel experiences.", highlight: true },
    { title: "France", img: france, desc: "France provides world-class education along with rich art, culture, and cuisine.", highlight: true },
    { title: "Germany", img: germany, desc: "Germany is known for strong technical programs, affordable tuition, and vibrant student life.", highlight: true },
    { title: "Singapore", img: singapore, desc: "Singapore offers a multicultural environment with top-ranked universities in Asia.", highlight: true },
    { title: "Switzerland", img: switzerland, desc: "Switzerland combines academic excellence with scenic beauty and international exposure.", highlight: true },
{ title: "Netherlands", img: Netherland, desc: "The Netherlands combines top-quality education with innovation and a welcoming international environment.", highlight: true },
{ title: "Italy", img: Italy, desc: "Italy blends academic excellence with a rich historical heritage and modern lifestyle.", highlight: true },
{ title: "Poland", img: Poland, desc: "Poland provides affordable education, a growing academic reputation, and a rich cultural experience.", highlight: true },
{ title: "Georgia", img: Georgia, desc: "Georgia is known for its affordable education, quality universities, and safe learning environment.", highlight: true },
{ title: "Russia", img: Russia, desc: "Russia offers globally recognized education, advanced research facilities, and diverse cultural exposure.", highlight: true },
{ title: "Kyrgyzstan", img: Kyrgyzstan, desc: "Kyrgyzstan provides cost-effective education with English-medium programs and international opportunities.", highlight: true },
{ title: "Kazakhstan", img: Kazakhstan, desc: "Kazakhstan offers modern education infrastructure, affordability, and a multicultural learning environment.", highlight: true },
{ title: "Uzbekistan", img: Uzbekistan, desc: "Uzbekistan is emerging as a hub for affordable and quality education with global opportunities.", highlight: true },
{ title: "Afghanistan", img: Afghanistan, desc: "Afghanistan is rebuilding its education system with growing opportunities for academic development.", highlight: true },
{ title: "China", img: China, desc: "China offers world-class education, advanced research opportunities, and a strong global academic presence for international students.", highlight: true },
{ title: "South Korea", img: SouthKorea, desc: "South Korea is known for its innovative education system, modern technology, and excellent career opportunities for students.", highlight: true }
];

const DestinationCarousel = () => {
  const swiperRef = useRef(null);

  return (
    <div className="destination-carousel container py-4">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div>
          <h2 className="fw-bold heading" >Know Your Destination</h2>
          <p className="mb-2 subtext">
            Experience top-quality education in these <br/> diverse and inviting destinations!
          </p>
        </div>
        <div className="d-flex gap-2">
          <button
            className="custom-arrow prev"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <FaChevronLeft />
          </button>
          <button
            className="custom-arrow next"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <FaChevronRight />
          </button>
        </div>
      </div>

      {/* Swiper */}
      <Swiper
        modules={[Autoplay, Navigation]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        spaceBetween={16}
        slidesPerView={4}
        breakpoints={{
          1024: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
        loop={true}
        speed={500}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
      >
        {destinations.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="p-2">
              <div className="destination-card   overflow-hidden position-relative">
                <img src={item.img} alt={item.title} className="img-fluid w-100" />
                 <div className="destination-title">{item.title}</div>
                {item.highlight ? (
                  <div className="overlay-content text-white p-3 d-flex flex-column justify-content-center">
                    <h5 className="fw-bold">{item.title}</h5>
                    <p>{item.desc}</p>
                    <a href="/Contact"><button className="btn btn-danger w-75 avail">
                      Avail FREE Counselling
                    </button></a>
                  </div>
                ) : (
                  <div className="destination-title bg-light text-center py-2">
                    <p className="m-0 fw-semibold">{item.title}</p>
                  </div>
                )}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DestinationCarousel;
